import axiosApiInstance from '../request';
const apiVersion = 'v2';
const patchPaymentTimeSheetStatusService = async (payload: any, Id: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.patch(`/timesheet/${Id}/`, payload, {
      headers,
      apiVersion
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};

const patchPaymentFixedStatusService = async (payload: any, Id: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.patch(`/milestone/${Id}/`, payload, {
      headers,
      apiVersion
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};

export { patchPaymentFixedStatusService, patchPaymentTimeSheetStatusService };
